import { expenseTypeColors } from '../_constants/graphicsColors'

export default {
  computed: {
      expenseTypeColors () {
        return expenseTypeColors
      }
  },
  methods: {
    getExpenseTypeFromDashboardData () {
      let dashboardExpenseTypes = []

      if (this.expenseDashboardData) {
        this.expenseDashboardData.forEach(dashboardItem => {
          if (dashboardItem?.expenseTypes) {
            dashboardItem.expenseTypes.forEach(expenseType => {
              if (expenseType.expenseTypeId || expenseType.expenseTypeId === null) {
                const isExpenseTypeInDashboardExpenseTypes = dashboardExpenseTypes.find(el => el.id === expenseType.expenseTypeId)

                if (!isExpenseTypeInDashboardExpenseTypes) {
                  const newExpenseTypeData = {
                    id: expenseType.expenseTypeId,
                    label: this.$t(expenseType.expenseTypeName),
                    startDate: dashboardItem.dateSum,
                    endDate: this.filters.groupBy === 'month'
                    ? this.$moment.utc(dashboardItem.dateSum)
                      .endOf('month')
                      .format()
                    : this.$moment.utc(dashboardItem.dateSum)
                      .endOf('day')
                      .format(),
                      dataType: 'EXPENSE_TYPE',
                      dates: [],
                      data: [],
                      backgroundColor: ''
                  }

                  newExpenseTypeData.backgroundColor = this.getExpenseTypeColor(expenseType.expenseTypeName)

                  dashboardExpenseTypes.push(newExpenseTypeData)
                }
              }
            })
          }
        })
      }

      return dashboardExpenseTypes
    },
    generateExpenseTypeDataAgrupation () {
      const data = this.getExpenseTypeFromDashboardData()

      let dataset = [...data]

      this.expenseDashboardData.forEach(el => {
        dataset.forEach(expenseTypeInDataSet => {
          const isExpenseTypeInCurrentDataExpenseTypeList = el.expenseTypes.find(el => el.expenseTypeId === expenseTypeInDataSet.id)

          if (isExpenseTypeInCurrentDataExpenseTypeList) {
            expenseTypeInDataSet.data.push(
              Number.parseFloat(
                (
                  Math.round(
                    isExpenseTypeInCurrentDataExpenseTypeList.totalAmount * 100
                  ) / 100
                ).toFixed(2)
              )
            )
            expenseTypeInDataSet.dates.push(el.dateSum)
          } else {
            expenseTypeInDataSet.data.push(0)
            expenseTypeInDataSet.dates.push(el.dateSum)
          }
        })
      })

      return dataset
  },
  getExpenseTypeColor (expenseTypeName) {
    const expenseTypeColorToFind = this.expenseTypeColors.find(el => el.expenseTypeName === expenseTypeName)
    return expenseTypeColorToFind?.color ?? 'e4e6e5'
  }
}
}
